export const formatMobileNumber = (mobileNumber: string | null | undefined) => {
  if (!mobileNumber) return "-";

  const digits = mobileNumber.replace(/\D/g, "");

  if (!digits) return mobileNumber;

  let countryCode = "";
  let localNumber = digits;

  // Detect country code
  for (const localLength of [10, 9, 8]) {
    const possibleCountryLength = digits.length - localLength;

    if (possibleCountryLength > 0 && possibleCountryLength <= 3) {
      countryCode = digits.slice(0, possibleCountryLength);
      localNumber = digits.slice(possibleCountryLength);
      break;
    }
  }

  // Format local number
  if (localNumber.length === 10) {
    return `${countryCode ? `+${countryCode}` : ""}(${localNumber.slice(
      0,
      3,
    )}) ${localNumber.slice(3, 6)}-${localNumber.slice(6)}`;
  }

  if (localNumber.length === 7) {
    return `${countryCode ? `+${countryCode}` : ""}${localNumber.slice(
      0,
      3,
    )}-${localNumber.slice(3)}`;
  }

  return `${countryCode ? `+${countryCode} ` : ""}${localNumber}`;
};
